import { render, staticRenderFns } from "./busquedaProductos.vue?vue&type=template&id=7725b32e&"
import script from "./busquedaProductos.vue?vue&type=script&lang=js&"
export * from "./busquedaProductos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports